import makeMoment from '@common/moment/MomentFactory';
import LocalizationService from '@common/localization/LocalizationService';
import VcomProvider from '../../VcomProvider';

function dateTimeLocale(dateTime, config = {}) {
  if (dateTime === undefined || dateTime === null) {
    return config.empty ? config.empty : '';
  }
  return LocalizationService.localizeDateTimeFormat(dateTime, config.format);
}

function getLocaleDateFormat(format) {
  const locale = VcomProvider.LanguageSwitch.getCurrentLocale();
  return makeMoment.localeData(locale).longDateFormat(format);
}

function getLocaleDateFormatForDatePicker(format) {
  return this.getLocaleDateFormat(format).replace('YYYY', 'yyyy').replace('DD', 'dd');
}

const dateFormat = {
  methods: { dateTimeLocale, getLocaleDateFormatForDatePicker, getLocaleDateFormat },
  filters: { dateTimeLocale },
};
export default dateFormat;
